import { useEffect, useState } from 'react';
import { Keyboard } from '@capacitor/keyboard';
import { Capacitor } from '@capacitor/core';

export const useKeyboard = () => {
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);
  const [keyboardHeight, setKeyboardHeight] = useState(0);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      // Listen for keyboard events
      const keyboardWillShowListener = Keyboard.addListener('keyboardWillShow', (info) => {
        console.log('Keyboard will show with height:', info.keyboardHeight);
        setKeyboardHeight(info.keyboardHeight);
      });

      const keyboardWillHideListener = Keyboard.addListener('keyboardWillHide', () => {
        console.log('Keyboard will hide');
        setIsKeyboardVisible(false);
        setKeyboardHeight(0);
      });

      const keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', (info) => {
        console.log('Keyboard did show with height:', info.keyboardHeight);
        setIsKeyboardVisible(true);
        setKeyboardHeight(info.keyboardHeight);
      });

      const keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', () => {
        console.log('Keyboard did hide');
        setIsKeyboardVisible(false);
        setKeyboardHeight(0);
      });

      // Cleanup listeners
      return () => {
        keyboardWillShowListener.remove();
        keyboardWillHideListener.remove();
        keyboardDidShowListener.remove();
        keyboardDidHideListener.remove();
      };
    }
  }, []);

  return {
    isKeyboardVisible,
    keyboardHeight,
    showKeyboard: async () => {
      if (Capacitor.isNativePlatform()) {
        try {
          await Keyboard.show();
        } catch (error) {
          console.log('Error showing keyboard:', error);
        }
      }
    },
    hideKeyboard: async () => {
      if (Capacitor.isNativePlatform()) {
        try {
          await Keyboard.hide();
        } catch (error) {
          console.log('Error hiding keyboard:', error);
        }
      }
    }
  };
};
